import CircularProgress from '@mui/material/CircularProgress';
import { ApolloError } from '@apollo/client';

import {
  ContainerColumnLeft,
  ContainerColumnsWrapper,
  Typography,
  Card,
  CardHeader,
  CardContent,
} from '@occc-app/design-system';
import { UnconfiguredOfferComponentPanel } from '@occc-app/Offer/components';
import { OfferFragment } from '@occc/graphql';
import { PrimaryInformation } from './components/PrimaryInformation';
import { Limits } from './components/Limits';
import Constraints from './components/Constraints';
import MarketingContent from './components/MarketingContent';
import EarningMechanism from './components/EarningMechanism';
import { offerCommonDescription } from './constants';

interface IOfferDetailsProps {
  loading: boolean;
  error?: ApolloError;
  offer?: OfferFragment;
}

export const OfferDetails: React.FC<IOfferDetailsProps> = ({ loading, error, offer }) => {
  if (error) {
    return <Typography color='error'>Something went wrong. Please try again.</Typography>;
  }
  if (loading && !offer) {
    return <CircularProgress />;
  }
  if (!offer) {
    return <Typography color='error'>No data. Something went wrong. Please try again.</Typography>;
  }

  return (
    <ContainerColumnsWrapper>
      <ContainerColumnLeft>
        <Card>
          <CardHeader
            title={
              <Typography variant='h6' component='h3' gutterBottom>
                Offer Details
              </Typography>
            }
            subheader={
              <Typography>
                {(offerCommonDescription as any)[offer.earningMechanism?.__typename || '']}
              </Typography>
            }
            sx={{ backgroundColor: (theme) => theme.palette.success.light, mb: 3 }}
          />
          <CardContent>
            <PrimaryInformation offer={offer} />
          </CardContent>
        </Card>
      </ContainerColumnLeft>
      {offer.marketingContents?.length ? (
        <ContainerColumnLeft>
          <MarketingContent marketingContents={offer.marketingContents} />
        </ContainerColumnLeft>
      ) : null}
      {offer.earningMechanism ? (
        <ContainerColumnLeft>
          <EarningMechanism earningMechanism={offer.earningMechanism} />
        </ContainerColumnLeft>
      ) : null}
      <ContainerColumnLeft>
        {offer.constraints.length ? (
          <Constraints constraints={offer.constraints} />
        ) : (
          <UnconfiguredOfferComponentPanel title='Constraints' />
        )}
      </ContainerColumnLeft>
      <ContainerColumnLeft>
        {offer.limits.length ? (
          <Limits limits={offer.limits} />
        ) : (
          <UnconfiguredOfferComponentPanel title='Limits' />
        )}
      </ContainerColumnLeft>
    </ContainerColumnsWrapper>
  );
};
